import BossModel from "@/models/BossModel";
import Party from "@/models/PhoneCall/Party/Party";
import Transcription from "@/models/PhoneCall/Transcription/Transcription.js";

export default class PhoneCall extends BossModel {
    /**
     *
     * @type {string}
     */
    static apiUrl = "phone-call";

    /**
     *
     * @type {string}
     */
    static entity = "phoneCalls";

    static fields() {
        return {
            id: this.attr(null),
            reference: this.attr(null),
            transferring_party_id: this.attr(null),
            from_party_id: this.attr(null),
            to_party_id: this.attr(null),
            dossier_id: this.attr(null),
            start_time: this.attr(null),
            answered_time: this.attr(null),
            end_time: this.attr(null),
            message: this.attr(null),
            created_at: this.attr(null),
            system: this.attr(null),
            file_id: this.attr(null),
            transcription: this.hasOne(Transcription, "phone_call_id"),
            from: this.belongsTo(Party, "from_party_id"),
            to: this.belongsTo(Party, "to_party_id"),
            transferring: this.belongsTo(Party, "transferring_party_id"),
        };
    }

    /**
     *
     * @returns {boolean|*}
     */
    To() {
        return this.getRelated("to");
    }

    /**
     *
     * @returns {boolean|*}
     */
    From() {
        return this.getRelated("from");
    }

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static loadByDossier(dossierId) {
        return this.api()
            .where("dossier_id", dossierId)
            .limit(0)
            .with([
                "from",
                "from.user",
                "from.customer",
                "to",
                "to.user",
                "to.customer",
                "transferring.user",
            ])
            .get(false);
    }
}
